import { useTranslation } from 'react-i18next';

const problems = [
  { icon: 'ri-flask-line', color: 'text-red-500', bg: 'bg-red-50', titleKey: 'wp1_title', descKey: 'wp1_desc' },
  { icon: 'ri-skull-line', color: 'text-orange-500', bg: 'bg-orange-50', titleKey: 'wp2_title', descKey: 'wp2_desc' },
  { icon: 'ri-bug-line', color: 'text-amber-600', bg: 'bg-amber-50', titleKey: 'wp3_title', descKey: 'wp3_desc' },
  { icon: 'ri-drop-line', color: 'text-sky-500', bg: 'bg-sky-50', titleKey: 'wp4_title', descKey: 'wp4_desc' },
  { icon: 'ri-medicine-bottle-line', color: 'text-purple-500', bg: 'bg-purple-50', titleKey: 'wp5_title', descKey: 'wp5_desc' },
  { icon: 'ri-test-tube-line', color: 'text-emerald-500', bg: 'bg-emerald-50', titleKey: 'wp6_title', descKey: 'wp6_desc' },
];

export default function WaterProblems() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-sky-400 text-sm font-bold uppercase tracking-widest">{t('wp_tag')}</span>
          <h2 className="text-4xl font-black text-white mt-3 mb-4">
            {t('wp_title1')}<br />{t('wp_title2')}
          </h2>
          <p className="text-slate-400 text-base max-w-2xl mx-auto">
            {t('wp_desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {problems.map((problem) => (
            <div key={problem.titleKey} className="bg-white/5 border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-all duration-200">
              <div className={`w-11 h-11 ${problem.bg} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${problem.icon} ${problem.color} text-xl`}></i>
              </div>
              <h3 className="text-white font-bold text-base mb-2">{t(problem.titleKey)}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{t(problem.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-sky-600/20 border border-sky-500/30 rounded-2xl p-7 flex flex-col sm:flex-row items-center gap-5">
          <div className="w-14 h-14 bg-sky-500/20 rounded-full flex items-center justify-center shrink-0">
            <i className="ri-information-line text-sky-400 text-3xl"></i>
          </div>
          <div>
            <h4 className="text-white font-bold text-base mb-1">{t('wp_cta_title')}</h4>
            <p className="text-slate-300 text-sm">{t('wp_cta_desc')}</p>
          </div>
          <div className="shrink-0">
            <a href="#water-form" className="bg-sky-500 hover:bg-sky-400 text-white font-bold px-6 py-3 rounded-lg whitespace-nowrap transition-colors cursor-pointer text-sm inline-block">
              {t('wp_cta_btn')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
